function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Path, {
  d: "M9.349 13.961a8.95 8.95 0 018.95 8.95.6.6 0 01-.6.6H1.001a.6.6 0 01-.6-.6 8.949 8.949 0 018.948-8.95zm0 1.2a7.749 7.749 0 00-7.714 7.018l-.01.131h15.449l-.01-.131a7.75 7.75 0 00-7.469-7.014zm10.996-3.949a8.95 8.95 0 018.95 8.95.6.6 0 01-.503.592l-.097.008h-9.584a.6.6 0 01-.097-1.192l.097-.008 8.96-.001-.009-.131a7.751 7.751 0 00-7.47-7.014l-.246-.004c-2.03 0-3.935.783-5.37 2.163a.6.6 0 11-.831-.865 8.917 8.917 0 016.201-2.498zM9.351 3.149a5.035 5.035 0 015.036 5.037 5.036 5.036 0 11-10.073 0 5.036 5.036 0 015.037-5.037zm0 1.2c-2.12 0-3.837 1.717-3.837 3.837a3.836 3.836 0 107.673 0 3.836 3.836 0 00-3.836-3.837zM20.346.4a5.036 5.036 0 110 10.073 5.036 5.036 0 110-10.073zm0 1.2a3.836 3.836 0 100 7.673 3.836 3.836 0 100-7.673z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgIconMembres(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24
  }, props), _ref);
}

export default SvgIconMembres;